import { Switchboard } from "../../lib/events";
import { ToolbarButton } from "../../lib/ui/toolbar/buttons";
export class CancelSelectButton extends ToolbarButton {
    constructor(layer) {
        super('times', 'Exit Result Set View', 'cancelSelectButton');
        this.layer = layer;
        this.emitter = Switchboard.get_emitter("CONTEXT");
    }
    _action() {
        this.layer.remove_features_except(this.layer.clicked);
        this.emitter.emit('ctx_request', 'singleton');
        this.ui.removeClass('highlighted');
    }
}
